import { render, staticRenderFns } from "./StatementsTabs.vue?vue&type=template&id=a607dd20"
import script from "./StatementsTabs.vue?vue&type=script&lang=js"
export * from "./StatementsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports